import Splitting from 'splitting';
import { initTestimonialsSwiper } from '../swiper/testimonials';
import { initProjectSwiper } from '../swiper/projects';
import { initWpSwipers } from '../swiper/wp-swiper';
import { initServiceSwiper } from '../swiper/services';
import { initClientLogosSwiper } from '../swiper/clients';
import { initMagnificPopup } from '../magnific-popup/general';
import { initNavigationHoverEffects } from '../components/navigation';
import { initWidgets } from '../widgets/general';
import { initBlockHeadings } from '../blocks/general';
import 'sharer.js';
 
export default {
  init() {
    initMagnificPopup();
    initNavigationHoverEffects();
    initWidgets();
    initBlockHeadings();
    initProjectSwiper();
    initTestimonialsSwiper();
    initClientLogosSwiper();
    initWpSwipers();
    initServiceSwiper();
  },

  finalize() {
    // Initialize sharer.js for all data-sharer elements
    if (window.Sharer) {
      window.Sharer.init();
    }
    
    const headingSelectors = '.post-header .ragged a, .testifier-name span';
// const headingSelectors = '.ragged span';

// Store original text and attributes first
$(headingSelectors).each(function() {
  const $el = $(this);
  
  if (!$el.data('original-text')) {
    // Check if element contains nested links or other elements
    const $nestedLink = $el.find('a');
    
    if ($nestedLink.length > 0) {
      // Store nested link info
      $el.data('has-nested-link', true);
      $el.data('nested-link-attrs', {});
      $.each($nestedLink[0].attributes, function() {
        $el.data('nested-link-attrs')[this.name] = this.value;
      });
      $el.data('original-text', $nestedLink.text().trim());
    } else {
      $el.data('has-nested-link', false);
      const textContent = $el.text().trim();
      $el.data('original-text', textContent);
    }
    
    $el.data('original-tag', $el.prop('tagName').toLowerCase());
    
    // Store all attributes of the main element, but handle class separately
    const attrs = {};
    $.each($el[0].attributes, function() {
      if (this.name !== 'class') {
        attrs[this.name] = this.value;
      }
    });
    $el.data('original-attrs', attrs);
    
    $el.data('original-classes', $el.attr('class') || '');
  }
});

function applySplitting() {
  
  $(headingSelectors).each(function() {
    const $el = $(this);
    
    const originalText = $el.data('original-text');
    const originalTag = $el.data('original-tag');
    const originalAttrs = $el.data('original-attrs');
    const originalClasses = $el.data('original-classes');
    const hasNestedLink = $el.data('has-nested-link');
    const nestedLinkAttrs = $el.data('nested-link-attrs');
    
    
    if (!originalText) {
      return;
    }
    
    // Create a new element with the same tag type
    const $newElement = $('<' + originalTag + '></' + originalTag + '>');
    
    // Restore all original attributes (except class)
    $.each(originalAttrs, function(name, value) {
      $newElement.attr(name, value);
    });
    
    // Restore original classes
    if (originalClasses) {
      $newElement.attr('class', originalClasses);
    }
    
    if (hasNestedLink) {
      // Create nested link with original attributes
      const $newLink = $('<a></a>').text(originalText);
      $.each(nestedLinkAttrs, function(name, value) {
        $newLink.attr(name, value);
      });
      $newElement.append($newLink);
    } else {
      // Set the text content directly
      $newElement.text(originalText);
    }
    
    
    // Replace the old element with the new one
    $el.replaceWith($newElement);
  });

  // Now run Splitting.js on the fresh elements
  const results = Splitting({ target: headingSelectors, by: 'lines' });
  
  // Post-process: wrap each line in a span
  $(headingSelectors).each(function() {
    const $el = $(this);
    
    // Restore data attributes to the new element if needed
    if (!$el.data('original-text')) {
      const $nestedLink = $el.find('a');
      
      if ($nestedLink.length > 0) {
        $el.data('has-nested-link', true);
        $el.data('nested-link-attrs', {});
        $.each($nestedLink[0].attributes, function() {
          $el.data('nested-link-attrs')[this.name] = this.value;
        });
        
        const text = $nestedLink.find('.word').map(function() {
          return $(this).text();
        }).get().join(' ');
        $el.data('original-text', text);
      } else {
        $el.data('has-nested-link', false);
        const text = $el.find('.word').map(function() {
          return $(this).text();
        }).get().join(' ');
        $el.data('original-text', text);
      }
      
      $el.data('original-tag', $el.prop('tagName').toLowerCase());
      
      const attrs = {};
      $.each($el[0].attributes, function() {
        if (this.name !== 'class') {
          attrs[this.name] = this.value;
        }
      });
      $el.data('original-attrs', attrs);
      
      // Store original classes (excluding Splitting classes)
      const currentClasses = ($el.attr('class') || '').split(' ').filter(function(cls) {
        return cls && !['words', 'lines', 'splitting', 'word'].includes(cls);
      }).join(' ');
      $el.data('original-classes', currentClasses);
    }
    
    const lines = {};
    
    // Group words by their line index - handle both direct words and words inside nested links
    const $words = $el.find('.word');
    
    $words.each(function() {
      const $word = $(this);
      const lineIndex = $word.attr('data-line') || $word.css('--line-index') || '0';
      const wordText = $word.text();
      
      if (!lines[lineIndex]) {
        lines[lineIndex] = [];
      }
      lines[lineIndex].push($word);
    });
    
    
    // If no words were found, it means Splitting didn't work - keep original text
    if (Object.keys(lines).length === 0) {
      return;
    }
    
    // Check if we need to preserve nested link structure
    const hasNestedLink = $el.data('has-nested-link');
    const nestedLinkAttrs = $el.data('nested-link-attrs');
    
    
    // Clear element
    $el.empty();
    
    if (hasNestedLink) {
      // Recreate with nested link structure
      const $newLink = $('<a></a>');
      $.each(nestedLinkAttrs, function(name, value) {
        $newLink.attr(name, value);
      });
      
      // Wrap each line inside the link
      const lineKeys = Object.keys(lines).sort((a, b) => a - b);
      lineKeys.forEach((lineIndex, idx) => {
        const $lineSpan = $('<span class="split-line"></span>');
        lines[lineIndex].forEach($word => {
          $lineSpan.append($word);
          $lineSpan.append(' ');
        });
        $newLink.append($lineSpan);
        if (idx < lineKeys.length - 1) {
          $newLink.append(' ');
        }
      });
      
      $el.append($newLink);
    } else {
      // Wrap each line directly
      const lineKeys = Object.keys(lines).sort((a, b) => a - b);
      lineKeys.forEach((lineIndex, idx) => {
        const $lineSpan = $('<span class="split-line"></span>');
        lines[lineIndex].forEach($word => {
          $lineSpan.append($word);
          $lineSpan.append(' ');
        });
        $el.append($lineSpan);
        if (idx < lineKeys.length - 1) {
          $el.append(' ');
        }
      });
    }
  });
  
}

// Initial split
applySplitting();

// Re-split on resize
let resizeTimer;
$(window).on('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    applySplitting();
  }, 250);
});

  }, // finalize()
}; // export default